import React from 'react';

import SelectMenyAdAction from './SelectMenyAdAction';
import {
  SERVICE_MENY_LIGHT,
  SERVICE_MENY,
  SERVICE_MENY_GO,
} from 'src/consts/MENY_SERVICE';
import SelectMenyLightAdAction from './SelectMenyLightAdAction';
import { isUndefined, isNull } from 'lodash';

import active_lang from 'src/langs/jp_en';

export default function SelectAdAction({ service_class, formik }) {
  if (isUndefined(service_class) || isNull(service_class)) {
  } else {
    switch (service_class.id) {
      case SERVICE_MENY:
        return <SelectMenyAdAction formik={formik} />;

      case SERVICE_MENY_LIGHT:
        return <SelectMenyLightAdAction formik={formik} />;

      case SERVICE_MENY_GO:
        return <SelectMenyAdAction formik={formik} />;

      default:
        return <>{JSON.stringify(service_class, null, 2)}</>;
    }
  }

  return <>{active_lang.AD_ACTION_LOADING}</>;
}
